export const INDIVIDUAL = '0';
export const COMPANY = '1';
export const SOLE_TRADER = '2';
export const PARTNERSHIP = '3';


